import { render, staticRenderFns } from "./failed-workflows.vue?vue&type=template&id=ab7e4614&scoped=true"
import script from "./failed-workflows.vue?vue&type=script&lang=js"
export * from "./failed-workflows.vue?vue&type=script&lang=js"
import style0 from "./failed-workflows.vue?vue&type=style&index=0&id=ab7e4614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7e4614",
  null
  
)

export default component.exports